/* global gon */

export function fogUrl(path) {
  return gon.global.fog.endpoint + gon.global.fog.bucket + "/" + path;
}

export function currentUserFullName() {
  return gon.currentUser.full_name;
}
